/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetCurrentUserQueryResponse, GetCurrentUser400, GetCurrentUser401, GetCurrentUser403, GetCurrentUser404, GetCurrentUser409, GetCurrentUser500 } from "../../types/userController/GetCurrentUser.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetCurrentUserUrl() {
  const res = { method: 'GET', url: `/api/users/me` as const }
  return res
}

/**
 * @summary Get current user profile
 * {@link /api/users/me}
 */
export async function getCurrentUser(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetCurrentUserQueryResponse, ResponseErrorConfig<GetCurrentUser400 | GetCurrentUser401 | GetCurrentUser403 | GetCurrentUser404 | GetCurrentUser409 | GetCurrentUser500>, unknown>({ method : "GET", url : getGetCurrentUserUrl().url.toString(), ... requestConfig })
  return res.data
}